import { render, staticRenderFns } from "./scroll-icon.vue?vue&type=template&id=054d583d&scoped=true&"
import script from "./scroll-icon.vue?vue&type=script&lang=js&"
export * from "./scroll-icon.vue?vue&type=script&lang=js&"
import style0 from "./scroll-icon.vue?vue&type=style&index=0&id=054d583d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d583d",
  null
  
)

export default component.exports